import lodash from 'lodash';

const formatFieldsObjToSnake = (obj) =>
  lodash.mapKeys(obj, (value, key) =>
    key
      .replace(/\.?([A-Z]+)/g, '_$1')
      .toLowerCase()
      .replace(/^_/, '')
  );
export default formatFieldsObjToSnake;
